import { render } from "./VabeneFaqPage.vue?vue&type=template&id=929eba7a&ts=true"
import script from "./VabeneFaqPage.vue?vue&type=script&lang=ts"
export * from "./VabeneFaqPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__